import request from '@/utils/request';
// 快手
// 单号复制解密
export function syncKsDecryptReceiveMessageApi(orderId, propTag, mallCode) {
  return request({
    url: '/ecom/ks/decryptInfo?orderId=' + orderId + '&propTag=' + propTag + '&mallCode=' + mallCode,
    method: 'post'
  });
}
// 快手新拉单接口
export function syncKsApplyWaybillApi(data) {
  return request({
    url: '/ecom/ks/applyWaybill',
    method: 'post',
    timeout: 100000,
    data
  });
}
// 快手获取历史老单号新接口
export function syncKsOldWaybillNoListApi(data) {
  return request({
    url: '/ecom/ks/getOrderOldWaybillNoList',
    method: 'post',
    data
  });
}
// 快手获取打印记录新接口
export function syncKsOrderPrintHistApi(data) {
  return request({
    url: '/ecom/ks/getOrderPrintHist',
    method: 'post',
    data
  });
}
// 获取列表数据--待发货、已发货面签
export function getKsOrderListForNewApi(data) {
  return request({
    url: '/ecom/ks/getOrders',
    method: 'post',
    data
  });
}
// 获取列表数据--全部页签
export function getKsAllOrderListForNewApi(data) {
  return request({
    url: '/ecom/ks/getAllOrders',
    method: 'post',
    data
  });
}
// 同步订单接口判断是否同步完毕
export function getKsSynOrderFlagForNewApi(data) {
  return request({
    url: '/ecom/ks/getSynOrderFlag',
    method: 'post',
    data
  });
}
// 快手 订单同步
export function kuaishouMallOrderUpdateForNewApi(data) {
  return request({
    url: '/ecom/ks/synOrders/' + data,
    timeout: 30000,
    method: 'post'
  });
}
// 快手 订单导出
export function kuaishouOrderExportForNewApi(data) {
  return request({
    url: '/ecom/ks/exportOrdersInfoNew',
    method: 'post',
    data,
    responseType: 'blob'
  });
}
// 快手 --编辑收件人信息
export function updateKuaishouReceiveInfoForNewApi(data) {
  return request({
    url: '/ecom/ks/updateReceiveInfo',
    method: 'post',
    data
  });
}
// 卖家留言旗帜打标
export function updateKuaishouSellerWordsForNewApi(data) {
  return request({
    url: '/ecom/ks/updateReceiveWords',
    method: 'post',
    data
  });
}
// 快手 --买家留言更新
export function updateKuaishouBuyerInfoForNewApi(data) {
  return request({
    url: '/ecom/ks/updateBuyerInfo',
    method: 'post',
    data
  });
}
// 快手 --商品简称更新
export function updateKuaishouProShortNameForNewApi(data) {
  return request({
    url: '/ecom/ks/updateProductShortName',
    method: 'post',
    data
  });
}
// 打印发货单状态刷新
export function updateKuaishouDeliverPrintedStatusForNewApi(data) {
  return request({
    url: '/ecom/ks/updateDeliverStatus?deliverPrintStatus=1',
    method: 'post',
    data
  });
}
// 快手 订单发货
export function kuaishouShipmentsSendForNewApi(data) {
  return request({
    url: '/ecom/ks/shipmentsSend',
    method: 'post',
    data
  });
}
// 快手--打印后重新发货
export function kuaishouRepeatShipmentsSendForNewApi(data) {
  return request({
    url: '/ecom/ks/shipmentsSendUpdate',
    method: 'post',
    data
  });
}
// 追加单号发货
export function ksShipmentsAppendSendApi(data) {
  return request({
    url: '/ecom/ks/shipmentsAppendSend',
    method: 'post',
    data
  });
}
// 当前账号下所有未打印订单拆分
export function splitKsUserAllOrderForNewApi(data) {
  return request({
    url: '/ecom/ks/splitUserAllOrder',
    method: 'post',
    data
  });
}
// 待合列表接口
export function getKsPreMergeListForNewApi(data) {
  return request({
    url: '/ecom/ks/getPreMergeList',
    method: 'post',
    data
  });
}
// 全部待合订单合并接口
export function mergeKsOrderAllForNewApi(data) {
  return request({
    url: '/ecom/ks/mergeOrderAll',
    method: 'post',
    data
  });
}
// 选择订单合并接口
export function mergeKsOrderForNewApi(data) {
  return request({
    url: '/ecom/ks/mergeOrder',
    method: 'post',
    data
  });
}
// 选择订单拆分接口
export function splitKsOrderForNewApi(data) {
  return request({
    url: '/ecom/ks/splitOrder',
    method: 'post',
    data
  });
}
// 全部拆单接口
export function splitKsOrderAllForNewApi(data) {
  return request({
    url: '/ecom/ks/splitOrderAll',
    method: 'post',
    data
  });
}
// 订单锁订与解锁接口
export function lockAndUnlockOrderForNewApi(data) {
  return request({
    url: '/ecom/ks/lockOrder',
    method: 'post',
    data
  });
}
// 查询快手商品信息列表
export function getKsOrderProductApi(data) {
  return request({
    url: '/ecom/ks/getAllOrderProduct',
    method: 'post',
    data
  });
}
// 查询快手商品规格信息列表
export function getKsProductSpecApi(data) {
  return request({
    url: '/ecom/ks/getOrderProductSku',
    method: 'post',
    data
  });
}
export function ksGetAllOrderNewProductApi(data) {
  return request({
    url: '/ecom/ks/getAllOrderNewProduct',
    method: 'post',
    data
  });
}
// 查询快手旗帜列表
export function getAllOrderFlagListForNewApi(data) {
  return request({
    url: '/ecom/base/getFlagCode',
    method: 'post',
    data
  });
}
// 获取查询条件列表
export function getOrderSearchListApi(data) {
  return request({
    url: '/ecom/base/getAllQuery',
    method: 'post',
    data
  });
}
// 删除查询条件列表
export function deleteOrderSearchListApi(data) {
  return request({
    url: '/ecom/base/deleteQuery',
    method: 'post',
    data
  });
}
// 添加查询条件列表
export function addOrderSearchListApi(data) {
  return request({
    url: '/ecom/base/insertQuery',
    method: 'post',
    data
  });
}
// 订单查询店铺是否授权
export function mallIfAuthorizedForKsApi(data) {
  return request({
    url: '/ecom/ks/mallIfAuthorized',
    method: 'post',
    data
  });
}
// 订单查询统计个数
export function getAllNewOrdersCountForKsApi(data) {
  return request({
    url: '/ecom/ks/getOrdersCount',
    method: 'post',
    data
  });
}
// 自动合单设置新增或更新
export function addMergeConfigApi(data) {
  return request({
    url: '/ecom/autoMergeConfig/addConfig',
    method: 'post',
    data
  });
}
// 自动合单设置查询
export function queryMergeConfigApi(data) {
  return request({
    url: '/ecom/autoMergeConfig/queryConfig',
    method: 'post',
    data
  });
}
// 快手面单账号余额查询
export function ksWaybillBalanceApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/ksShopList',
    method: 'post',
    data
  });
}
// 快手订单批量预发货
export function updateKsPreShipOrdersApi(data) {
  return request({
    url: '/ecom/ks/updatePreShipOrders',
    method: 'post',
    data
  });
}
// 快手订单批量取消预发货
export function updateKsCancelPreShipOrdersApi(data) {
  return request({
    url: '/ecom/ks/updateCancelPreShipOrders ',
    method: 'post',
    data
  });
}
// 快手订单预发货 --暂停、恢复
export function updateKsPreStatusOrdersApi(data) {
  return request({
    url: '/ecom/ks/updatePreStatusOrders ',
    method: 'post',
    data
  });
}
// 快手根据订单Id更新订单
export function ksSynOrderByOrderIdApi(data) {
  return request({
    url: '/ecom/ks/synOrderByOrderId',
    method: 'post',
    timeout: 30000,
    data
  });
}
// 快手按时间段更新订单
export function ksSynTimeSlotOrdersApi(data) {
  return request({
    url: '/ecom/ks/synTimeSlotOrders',
    method: 'post',
    timeout: 30000,
    data
  });
}
// 选择订单-拆单接口
export function splitBatchOrderApi(data) {
  return request({
    url: '/ecom/ks/splitBatchOrder',
    method: 'post',
    data
  });
}
// 更新圆通优选时效的接口
export function ytoKsPerferTimeFlagSynApi(data) {
  return request({
    url: '/ecom/ks/ytoPerferTimeFlagSyn',
    method: 'post',
    data
  });
}

// 保存管家备注接口
export function updateKsKhgjRemarkApi(data) {
  return request({
    url: '/ecom/ks/updateKhgjRemark',
    method: 'post',
    data
  });
}
